import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    CircularProgress,
    Box,
    Typography,
    Chip,
    TextField,
    InputAdornment,
    IconButton,
    MenuItem,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";
import toast from "react-hot-toast";
import { Formik } from "formik";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import * as Yup from "yup";
import { tokens } from "../../Theme";
import { formGap } from "../../ui-components/global/utils";
import { LeaveTypeAutocomplete } from "../../ui-components/global/Autocomplete";
import { DashboardVisualLeaveApproval } from "../../store/reducers/Formapireducer";
import { dashBoard_V2 } from "../../store/reducers/LoginReducer";


export default function LeaveApprovalModal({ open, onClose, rowData, EmployeeID, ManagerID, parameters }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const compID = sessionStorage.getItem("companyId");
    const EMPID = sessionStorage.getItem("EmpId");
    const dispatch = useDispatch();
    var secondaryCurrentPage = parseInt(
        sessionStorage.getItem("secondaryCurrentPage")
    );
    const paramss = parameters? parameters : "";
    console.log("****parameters in LeaveApprovalModal", paramss,ManagerID);
    const [pageSize, setPageSize] = React.useState(20);
    const [page, setPage] = React.useState(secondaryCurrentPage);
    const params = useParams();
    const location = useLocation();
    const theme = useTheme();
    const state = location.state || {};
    //   const HeaderID = state.HeaderID || 0
    const HeaderID = rowData?.RecordID || 0
    const colors = tokens(theme.palette.mode);
    const [validationSchema, setValidationSchema] = useState(null);
    const [errorMsgData, setErrorMsgData] = useState(null);

    const [showPassword, setShowPassword] = useState(false);
    const [leaveDetails, setLeaveDetails] = useState(null);
    const listViewurl = useSelector((state) => state.globalurl.listViewurl);

    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };
    const appliedYearLookup = new Date(
        rowData?.applieddate,
    ).getFullYear();
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const [dd, mm, yyyy] = dateStr.split("-");
        return `${yyyy}-${mm}-${dd}`;
    };
    const initialValues = {

        FromDate: formatDate(rowData?.from),
        ToDate: formatDate(rowData?.to),
        Comments: rowData?.leavecomments || "",
        LeaveType: rowData?.LeaveTypeName || "",
        LeavePart: rowData?.leavepart || "",
        Status: "",
        ManagerComments: "",

    }

    const LeaveApprovalSave = async (values) => {
        const idata = {
            LeaveID: rowData?.leaveid || "",
            EmployeeID: rowData?.id || "",
            FromDate: formatDate(rowData?.from) || "",
            ToDate: formatDate(rowData?.to) || "",
            LeavePart: rowData?.leavepart || "",
            LeaveTypeID: rowData?.leavetypeid || "",
            Status: values.Status || "",
            ManagerComments: values.ManagerComments || "",
            ApprovedBy: EMPID,
        }
        const response = await dispatch(DashboardVisualLeaveApproval({ idata }));
        if (response.payload.Status === "Y") {
            toast.success(response.payload.Msg);
            
           dispatch(dashBoard_V2({ data: { EmployeeID: ManagerID, Type: paramss, CompanyID: compID } }));
             
            onClose();
        }
        else {
            toast.error(response.payload.Msg);

        }
    }
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{ sx: { borderRadius: 2 } }}
        >
            {/* Header */}
            <DialogTitle sx={{ pb: 1 }}>
                <Typography variant="h5" fontWeight="600">
                    Leave Approval ({rowData?.name || ""}) &nbsp;
                </Typography>
            </DialogTitle>

            {/* Body */}
            <DialogContent dividers sx={{ px: 2, py: 1 }}>
                {/* Loading */}
                {loading && (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight={100}>
                        <CircularProgress />
                    </Box>
                )}

                {/* Error */}
                {!loading && error && (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight={100}>
                        <Typography color="error">{error}</Typography>
                    </Box>
                )}

                {/* DataGrid */}
                {!loading && !error && (

                    <Box
                        sx={{
                            height: 450,
                            width: "100%",
                        }}

                    >
                        <Formik
                            initialValues={initialValues}
                            onSubmit={(values) => {
                                setTimeout(() => {
                                    LeaveApprovalSave(values);
                                }, 100);
                            }}
                            enableReinitialize={true}
                            // validationSchema={validationSchema}
                            validate={(values) => {
                                const errors = {};
                                if (!values.ManagerComments) {
                                    errors.ManagerComments = "Please Enter Manager Comments";
                                }
                                if (!values.Status) {
                                    errors.Status = "Please Select Status";
                                }
                                return errors;
                            }}
                        >
                            {({
                                errors, touched, handleBlur,
                                handleChange, values, handleSubmit,
                                setFieldValue,
                            }) => {
                                return (
                                    <form onSubmit={handleSubmit}>
                                        <Box
                                            gap={formGap}
                                            padding={1}
                                            display="flex" flexDirection="column"
                                        >

                                            {/* LeaveType (readonly) */}
                                            <TextField
                                                variant="standard"
                                                label="Leave Type"
                                                name="LeaveType"
                                                // value={leaveDetails.comments || ""}
                                                value={values.LeaveType}
                                                fullWidth
                                                multiline
                                                InputProps={{ readOnly: true }}
                                                focused
                                            />

                                            {/* From Date */}
                                            <TextField
                                                label="From Date"
                                                type="date"
                                                name="FromDate"
                                                // value={leaveDetails.fromDate || ""}
                                                value={values.FromDate}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ readOnly: true }}
                                                fullWidth
                                                focused
                                            />

                                            {/* To Date */}
                                            <TextField
                                                label="To Date"
                                                type="date"
                                                name="ToDate"
                                                // value={leaveDetails.toDate || ""}
                                                value={values.ToDate}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ readOnly: true }}
                                                fullWidth
                                                focused
                                            />

                                            {/* Comments (readonly) */}
                                            <TextField
                                                variant="standard"
                                                label="Comments"
                                                name="Comments"
                                                // value={leaveDetails.comments || ""}
                                                value={values.Comments}
                                                fullWidth
                                                multiline
                                                InputProps={{ readOnly: true }}
                                                focused
                                            />                                            {/* Leave Part */}
                                            <TextField
                                                select
                                                label="Leave Part"
                                                value={values.LeavePart}
                                                name="LeavePart"
                                                variant="standard"
                                                // onChange={(e) =>
                                                //     setLeaveDetails(prev => ({
                                                //         ...prev,
                                                //         status: e.target.value
                                                //     }))
                                                // }
                                                onChange={handleChange}
                                                fullWidth
                                                focused
                                                InputProps={{ readOnly: true }}
                                            // SelectProps={{ native: true }}
                                            >
                                                <MenuItem value="FH">First Half</MenuItem>
                                                <MenuItem value="SH">Second Half</MenuItem>
                                                <MenuItem value="N">Full Day</MenuItem>
                                            </TextField>
                                            {/* Manager Comments */}
                                            <TextField
                                                // label="Manager Comments"
                                                label={
                                                    <>
                                                        Manager Comments<span style={{ color: "red", fontSize: "20px" }}> * </span>
                                                    </>
                                                }
                                                name="ManagerComments"
                                                variant="standard"
                                                // value={leaveDetails.managerComments || ""}
                                                value={values.ManagerComments}
                                                fullWidth
                                                multiline
                                                onChange={handleChange}
                                                focused
                                                error={!!touched.ManagerComments && !!errors.ManagerComments}
                                                helperText={touched.ManagerComments && errors.ManagerComments}
                                            />


                                            {/* Status */}
                                            <TextField
                                                select
                                                // label="Status"
                                                label={
                                                    <>
                                                        Status<span style={{ color: "red", fontSize: "20px" }}> * </span>
                                                    </>
                                                }
                                                // value={leaveDetails.status || ""}
                                                value={values.Status}
                                                name="Status"
                                                variant="standard"
                                                // onChange={(e) =>
                                                //     setLeaveDetails(prev => ({
                                                //         ...prev,
                                                //         status: e.target.value
                                                //     }))
                                                // }
                                                onChange={handleChange}
                                                fullWidth
                                                focused
                                                error={!!touched.Status && !!errors.Status}
                                                helperText={touched.Status && errors.Status}
                                            // SelectProps={{ native: true }}
                                            >
                                                <MenuItem value="AP">Approved</MenuItem>
                                                <MenuItem value="RJ">Rejected</MenuItem>
                                                <MenuItem value="QR">Query</MenuItem>
                                            </TextField>
                                        </Box>

                                        <Box
                                            display="flex"
                                            justifyContent="end"
                                            padding={1}
                                            gap="20px"
                                        >

                                            <LoadingButton
                                                color="secondary"
                                                variant="contained"
                                                type="submit"
                                            // loading={isLoading}
                                            >
                                                Save
                                            </LoadingButton>
                                            {" "}

                                            <Button
                                                color="warning"
                                                variant="contained"
                                                onClick={onClose}
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    </form>
                                )
                            }}
                        </Formik>
                    </Box>
                )
                }
            </DialogContent>

            {/* Footer */}
            {/* <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} variant="contained" disableElevation color="warning">
                    Cancel
                </Button>
            </DialogActions> */}
        </Dialog>
    );
}